

import '../index.css';

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Route, useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { useAuth } from '../../../shared/AuthContext';
import rolePermissions from '../../../shared/rolePermissions';







const Component = ({ model }) => {

  const navigate = useNavigate();

  const { slug } = useParams();
  const isEditMode = Boolean(slug);
  const [loading, setLoading] = useState(isEditMode);
  const [error, setError] = useState('');

  const { user, loadingSession } = useAuth();
  const canViewContent = rolePermissions.hasPermission(user, 'content.view');
  const canManageContent = rolePermissions.hasPermission(user, 'content.manage');

  
  const [saving, setSaving] = useState(false);
  const canSubmit = Boolean(canManageContent);


  
  const Service = {

    getRecord: ( searchParams ) => {

      const result = {};

      result.status = model.status.initial.value;
      result[model.handle.handle] = model.handle.initial ?? '';

      model.fields.forEach( ( field ) => {
        result[ field.handle ] = searchParams.get(field.handle) ?? field.initial;
      } );

      return {
        data: result
      };
    },

    getDomain: () => {

      const result = {};
      
      model.domain.forEach( ( item ) => {
        result[ item.handle ] = item.defaultValue ?? (['table', 'list'].includes(item.domain?.value) ? [] : {});
      } );

      return result;
    },

  };

  const [searchParams] = useSearchParams();

  const [form, setForm] = useState( Service.getRecord( searchParams ) );
  const [domain, setDomain] = useState( Service.getDomain() );

  useEffect(() => {

    const loadRecord = async () => {
      if (!isEditMode) return;

      setLoading(true);
      setError('');
      try {

        const Service = {

          getRecord: async ( slug, setForm ) => {

            const result = {};

            const Factory = require( '../../../records/modules' ).default;

            const row = await Factory( {
              slug: model.slug
            } ).Meta.getRecord( slug );

            result.data = row;

            setForm( result );
          },
            
          getDomain: async ( slug, setDomain ) => {

            const result = {};

            const Factory = require( '../../../records/modules' ).default;

            const row = await Factory( {
              slug: model.slug
            } ).Meta.getRecord( slug );

            model.domain.forEach( ( item ) => {
              result[ item.handle ] = row[ item.handle ] ?? item.defaultValue ?? (['table', 'list'].includes(item.domain.value) ? [] : {});
            } );

            setDomain( result );
          }

        };
        await Service.getRecord(slug, setForm);
        await Service.getDomain(slug, setDomain);
      } catch (err) {
        setError(`Record Error: ${err?.response?.data?.message || err.message || 'Unable to load Record.'}`);
      } finally {
        setLoading(false);
      }
    };

    loadRecord();
  }, [ model, slug, isEditMode ]);





  const [context, setContext] = useState({});
  const [contextLoading, setContextLoading] = useState(true);
  const [contextError, setContextError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const loadContext = async () => {
      setContextLoading(true);
      setContextError('');
      try {

        const result = {};

        const Factory = require( '../../../records/modules' ).default;

        const response = await Factory( {
          slug: 'models'
        } ).Meta.getRecords( {
          
        } );

        result.models = response.data || [];

        await Promise.all(model.domain.map((item) => {

          const Components = require( '../../../elements' ).default;

          const Component = Components.Meta.domain(item.domain.value);

          return Component.loadContext({
            handle: item.handle,
            meta: item.domain.meta,
            result,
          });
        }));

        if (!cancelled) setContext(result);
      } catch (err) {
        if (!cancelled) setContextError(`Context Error: ${err?.response?.data?.message || err.message || 'Unable to load Context.'}`);
      } finally {
        if (!cancelled) setContextLoading(false);
      }
    };

    loadContext();
    return () => { cancelled = true; };
  }, [ model ]);














  
  const RecordFormSection = require( '../../../components/record/RecordFormSection' ).default;


  function updateField(field, value) {
    setForm((prev) => ({ ...prev, data: { ...prev.data, [field]: value } }));
  }

  function updateDomain(nextDomain) {
    setDomain((prev) => (typeof nextDomain === 'function' ? nextDomain(prev) : nextDomain));
  }

  if (loadingSession) return <p>Checking access...</p>;
  if (!canViewContent) return <p className="error-text">You do not have permission to view this content.</p>;
  if (!canManageContent) return <p className="error-text">You do not have permission to manage this content.</p>;

  if (contextLoading) return <p>Loading form...</p>;
  if (contextError) return <p className="error-text">{contextError}</p>;
  if (loading) return <p>Loading form...</p>;



  const {
    handle,
    details
  } = {
    handle: {
      slug: model.slug,
      handle: model.handle,
      status: model.status,
      details: model.fields,
    },
    section: model.section,
    slug: model.slug,
    details: {
      items: model.domain
    }
  };
  
  return (
    <RecordFormSection
      error={error}
      slug={handle.slug}
      id={slug}
      header={{
        saving,
        isEditMode,
        canSubmit,
        onSubmit: async function handleSubmit(event) {
          event.preventDefault();
          if (!canManageContent) {
            setError('You do not have permission to manage this content.');
            return;
          }
          setSaving(true);
          setError('');
          try {

            const payload = { ...form.data };

            model.domain.forEach( ( item ) => {
              payload[ item.handle ] = domain[ item.handle ] ?? payload[ item.handle ] ?? null;
            } );

            const Factory = require( '../../../records/modules' ).default;

            const saved = slug
            ? await Factory( {
              slug: model.slug
            } ).Meta.updateRecord( slug, payload )
            : await Factory( {
              slug: model.slug
            } ).Meta.createRecord( payload );

            navigate(`/${handle.slug}/${saved.slug}`);
          } catch (err) {
            setError(err?.response?.data?.message || err.message || 'Unable to save record.');
          } finally {
            setSaving(false);
          }
        },
      }}
      data={{
        record: form,
        context: context,
        onFieldChange: updateField,
        hasStatus: true,
        initialStatus: handle.status.initial,
        handle: {
          handle: handle.handle.handle,
          label: handle.handle.label,
          meta: handle.handle.field.meta,
          value: handle.handle.field.value,
        },
        details: handle.details.map( ( field ) => ({
          handle: field.handle,
          label: field.label,
          meta: field.field.meta,
          value: field.field.value,
        }) )
      }}
    >

      {details.items.map( ( domainItem ) => {
      
        const Components = require( '../../../elements' ).default;

        const Component = Components.Meta.domain( domainItem.domain.value );

        return <Component.Input key={domainItem.handle} handle={domainItem.handle} meta={domainItem.domain.meta} context={context} domain={domain} updateDomain={updateDomain} />;
      } )}

    </RecordFormSection>
  );
};





export default Component;